import { render, staticRenderFns } from "./ExamIndex.vue?vue&type=template&id=b4895078&"
import script from "./ExamIndex.vue?vue&type=script&lang=js&"
export * from "./ExamIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports